import useLocalizedNavigate from 'hooks/useLocalizedNavigate';
import React, { ReactNode, useCallback } from 'react';
import { To } from 'react-router-dom';

type LocalizedNoIndexLinkType = {
  to: To;
  isReplace?: boolean;
  state?: any;
  children: ReactNode;
  analyticsCallback?: () => void;
  [name: string]: any;
};

const LocalizedNoIndexLink = ({
  to,
  isReplace = false,
  state,
  children,
  analyticsCallback,
  ...rest
}: LocalizedNoIndexLinkType) => {
  const navigate = useLocalizedNavigate();

  const handleClick = useCallback(() => {
    if (analyticsCallback && typeof analyticsCallback === 'function') {
      analyticsCallback();
    }

    navigate(to, { replace: isReplace, state: state });
  }, [analyticsCallback, isReplace, state, to, navigate]);

  return (
    <button onClick={handleClick} {...rest}>
      {children}
    </button>
  );
};

export default LocalizedNoIndexLink;
